import http from './http';

export default {
    getAll() {
        return http.get('/apikey');
    },
    create(apikey) {
        return http.post('/apikey', apikey);
    },
    update(apikey) {
        return http.put(`/apikey/${apikey.id}`, apikey);
    },
    delete({ id }) {
        return http.delete(`/apikey/${id}`);
    },
};
